var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-12" }, [
      _c("div", { staticClass: "card" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _c("fieldset", { staticClass: "border p-2" }, [
            _c("legend", { staticClass: "w-auto" }, [
              _vm._v("Filtro de Búsqueda")
            ]),
            _vm._v(" "),
            _c("form", [
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "Periodo" } }, [
                      _vm._v("Periodo ")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.period,
                          expression: "period"
                        }
                      ],
                      staticClass: "form-control",
                      class: { "is-invalid": _vm.periodError },
                      attrs: {
                        type: "number",
                        id: "period",
                        placeholder: "YYYYMM"
                      },
                      domProps: { value: _vm.period },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.period = $event.target.value
                          },
                          _vm.validatePeriod
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _vm.periodError
                      ? _c("div", { staticClass: "invalid-feedback" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.periodErrorMessage) +
                              "\n                                    "
                          )
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v(" RUT Cliente")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.customerID,
                          expression: "customerID"
                        }
                      ],
                      staticClass: "form-control",
                      class: { "is-invalid": _vm.customerIDError },
                      attrs: {
                        type: "text",
                        id: "customer-id",
                        placeholder: "XXXXXXXX-X"
                      },
                      domProps: { value: _vm.customerID },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.customerID = $event.target.value
                          },
                          function($event) {
                            return _vm.formatRut("customerID")
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _vm.customerIDError
                      ? _c("div", { staticClass: "invalid-feedback" }, [
                          _vm._v("Rut inválido")
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v(" RUT Beneficiario")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.beneficiaryID,
                          expression: "beneficiaryID"
                        }
                      ],
                      staticClass: "form-control",
                      class: { "is-invalid": _vm.beneficiaryIDError },
                      attrs: {
                        type: "text",
                        id: "beneficiary-id",
                        placeholder: "XXXXXXXX-X"
                      },
                      domProps: { value: _vm.beneficiaryID },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.beneficiaryID = $event.target.value
                          },
                          function($event) {
                            return _vm.formatRut("beneficiaryID")
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _vm.beneficiaryIDError
                      ? _c("div", { staticClass: "invalid-feedback" }, [
                          _vm._v("Rut inválido")
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label"),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-block mt-2",
                        attrs: {
                          type: "button",
                          disabled: _vm.isSearchDisabled
                        },
                        on: { click: _vm.search }
                      },
                      [
                        _vm._v(
                          "\n                                        Buscar\n                                    "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.beneficiaryIDError
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "Invalid beneficiary ID\n                                    format"
                        )
                      ])
                    : _vm._e()
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _vm.isLoader
            ? _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-center align-items-center loader-wrapper"
                },
                [_vm._m(1)]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isLoader
            ? _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-9" }, [
                  _vm.isVisibleResumen
                    ? _c("div", [
                        _c("fieldset", { staticClass: "border p-2" }, [
                          _c("legend", { staticClass: "w-auto" }, [
                            _vm._v("Resumen Procesamiento")
                          ]),
                          _vm._v(" "),
                          _vm._m(2),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "scroll-container overflow-auto p-2"
                            },
                            [
                              _c("div", { staticClass: "border px-5 py-3" }, [
                                _vm.isStandardProcess
                                  ? _c(
                                      "div",
                                      _vm._l(_vm.ProcessingSummary, function(
                                        summary
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key:
                                              summary.fileName +
                                              "-" +
                                              summary.processId,
                                            staticClass: "row"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "col-3 small" },
                                              [
                                                _vm._v(
                                                  "\n                                                    " +
                                                    _vm._s(summary.fileName) +
                                                    "\n                                                "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-9 progress mb-3 px-0",
                                                style: _vm.isHighlighted(
                                                  summary.processId,
                                                  summary.fileName
                                                )
                                                  ? {
                                                      border:
                                                        "3px solid #eeff00"
                                                    }
                                                  : { border: "none" }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-md-4 px-0 mb-5"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "progress reprocess-pb"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            class: [
                                                              summary.isCompleted
                                                                ? "progress-bar"
                                                                : "progress-bar progress-bar-striped progress-bar-animated",
                                                              summary.firstCSV &&
                                                              summary.firstCSV ==
                                                                "Failed"
                                                                ? "bg-danger"
                                                                : "bg-success"
                                                            ],
                                                            style: {
                                                              width:
                                                                summary.firstCSV &&
                                                                summary.firstCSV !==
                                                                  "Skipped"
                                                                  ? "100%"
                                                                  : "0%"
                                                            },
                                                            attrs: {
                                                              role:
                                                                "progressbar"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "mt-3 text-left pl-2"
                                                              },
                                                              [
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "font-weight-bold"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "N° Comprobantes: " +
                                                                        _vm._s(
                                                                          new Intl.NumberFormat(
                                                                            "es-CL"
                                                                          ).format(
                                                                            summary.numberOfReceipts
                                                                          )
                                                                        )
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "font-weight-bold"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "N° Comprobantes con error: " +
                                                                        _vm._s(
                                                                          new Intl.NumberFormat(
                                                                            "es-CL"
                                                                          ).format(
                                                                            summary.nonRenderedReceipts
                                                                          )
                                                                        )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "col-md-4 px-0"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "progress reprocess-pb"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            class: [
                                                              summary.isCompleted
                                                                ? "progress-bar"
                                                                : "progress-bar progress-bar-striped progress-bar-animated",
                                                              summary.nonRenderedReceipts >
                                                              0
                                                                ? "bg-danger"
                                                                : "bg-success"
                                                            ],
                                                            style: {
                                                              width:
                                                                (summary.isCompleted
                                                                  ? 100
                                                                  : summary.renderedReceiptsPercentage) +
                                                                "%"
                                                            },
                                                            attrs: {
                                                              role:
                                                                "progressbar"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "mt-3 pl-2"
                                                              },
                                                              [
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "font-weight-bold text-left"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "% de Avance : " +
                                                                        _vm._s(
                                                                          summary.isCompleted
                                                                            ? 100
                                                                            : summary.renderedReceiptsPercentage
                                                                        ) +
                                                                        "%"
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "col-md-4 px-0"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "progress reprocess-pb"
                                                      },
                                                      [
                                                        _c("div", {
                                                          class: [
                                                            summary.isCompleted
                                                              ? "progress-bar"
                                                              : "progress-bar progress-bar-striped progress-bar-animated",
                                                            (summary.secondCSV &&
                                                              summary.secondCSV ==
                                                                "Failed") ||
                                                            summary.nonRenderedReceipts >
                                                              0
                                                              ? "bg-danger"
                                                              : "bg-success"
                                                          ],
                                                          style: {
                                                            width:
                                                              summary.secondCSV &&
                                                              summary.secondCSV !==
                                                                "Skipped"
                                                                ? "100%"
                                                                : "0%"
                                                          },
                                                          attrs: {
                                                            role: "progressbar"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  : _c(
                                      "div",
                                      {
                                        staticClass: "alert alert-danger mb-0"
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            "No se ha ejecutado un proceso estándar de renderizado para los\n                                                filtros seleccionados"
                                          )
                                        ])
                                      ]
                                    )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "card my-2" },
                                _vm._l(_vm.ReprocessingSummary, function(
                                  reprocessSummary
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      key:
                                        reprocessSummary.processExecutionInfo
                                          .processId
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "card-header" },
                                        [
                                          _c("div", { staticClass: "row" }, [
                                            _c(
                                              "div",
                                              { staticClass: "col-md-4" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "user-details"
                                                  },
                                                  [
                                                    _c("p", [
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            reprocessSummary
                                                              .processExecutionInfo
                                                              .processTimestamp
                                                          ) +
                                                            " - " +
                                                            _vm._s(
                                                              reprocessSummary
                                                                .processExecutionInfo
                                                                .username
                                                            )
                                                        )
                                                      ])
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          reprocessSummary
                                                            .processExecutionInfo
                                                            .comment
                                                        ) +
                                                          "\n                                                            "
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "col-md-4" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "render-options"
                                                  },
                                                  [
                                                    _vm._m(3, true),
                                                    _vm._v(" "),
                                                    _c(
                                                      "ul",
                                                      { staticClass: "list" },
                                                      [
                                                        reprocessSummary
                                                          .processExecutionInfo
                                                          .actionFiltersRaw
                                                          .generateFirstNotification
                                                          ? _c("li", [
                                                              _vm._v(
                                                                "\n                                                                    CSV Notificación fecha pago"
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        reprocessSummary
                                                          .processExecutionInfo
                                                          .actionFiltersRaw
                                                          .renderLink
                                                          ? _c("li", [
                                                              _vm._v(
                                                                "\n                                                                    Renderizado"
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        reprocessSummary
                                                          .processExecutionInfo
                                                          .actionFiltersRaw
                                                          .generateSecondtNotification
                                                          ? _c("li", [
                                                              _vm._v(
                                                                "\n                                                                    CSV Notificación comprobante pago"
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        reprocessSummary
                                                          .processExecutionInfo
                                                          .actionFiltersRaw
                                                          .loadBase64
                                                          ? _c("li", [
                                                              _vm._v(
                                                                "\n                                                                    Carga IPS"
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "col-md-4" },
                                              [
                                                _c("p", [
                                                  _c(
                                                    "strong",
                                                    { staticClass: "ml-2" },
                                                    [
                                                      _vm._v(
                                                        "Periodo\n                                                                " +
                                                          _vm._s(_vm.period) +
                                                          " - ID Batch " +
                                                          _vm._s(
                                                            reprocessSummary
                                                              .processExecutionInfo
                                                              .batchId
                                                          ) +
                                                          "\n                                                            "
                                                      )
                                                    ]
                                                  )
                                                ])
                                              ]
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "card-body px-5 py-3" },
                                        [
                                          _c(
                                            "div",
                                            _vm._l(
                                              reprocessSummary.fileExecutionInfo,
                                              function(reprocessData) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key:
                                                      reprocessData.processId +
                                                      reprocessData.fileName,
                                                    staticClass: "row"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-md-3 small pl-0"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                                            " +
                                                            _vm._s(
                                                              reprocessData.fileName
                                                            ) +
                                                            "\n                                                        "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-md-9 progress mb-2 px-0",
                                                        style: _vm.isHighlighted(
                                                          reprocessData.processId,
                                                          reprocessData.fileName
                                                        )
                                                          ? {
                                                              border:
                                                                "3px solid #eeff00"
                                                            }
                                                          : { border: "none" }
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-md-4 px-0"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "progress reprocess-pb"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    class: [
                                                                      reprocessData.isCompleted
                                                                        ? "progress-bar"
                                                                        : "progress-bar progress-bar-striped progress-bar-animated",
                                                                      reprocessData.firstCSV &&
                                                                      reprocessData.firstCSV ==
                                                                        "Failed"
                                                                        ? "bg-danger"
                                                                        : "bg-success"
                                                                    ],
                                                                    style: {
                                                                      width:
                                                                        reprocessData.firstCSV &&
                                                                        reprocessData.firstCSV !==
                                                                          "Skipped" &&
                                                                        reprocessSummary
                                                                          .processExecutionInfo
                                                                          .actionFiltersRaw
                                                                          .generateFirstNotification
                                                                          ? "100%"
                                                                          : "0%"
                                                                    },
                                                                    attrs: {
                                                                      role:
                                                                        "progressbar"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "mt-3 text-left pl-2"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "p",
                                                                          {
                                                                            staticClass:
                                                                              "font-weight-bold"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "N°\n                                                                                Comprobantes: " +
                                                                                _vm._s(
                                                                                  new Intl.NumberFormat(
                                                                                    "es-CL"
                                                                                  ).format(
                                                                                    reprocessData.numberOfReceipts
                                                                                  )
                                                                                )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "p",
                                                                          {
                                                                            staticClass:
                                                                              "font-weight-bold"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " N° Comprobantes con error: " +
                                                                                _vm._s(
                                                                                  new Intl.NumberFormat(
                                                                                    "es-CL"
                                                                                  ).format(
                                                                                    reprocessData.nonRenderedReceipts
                                                                                  )
                                                                                )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-md-4 px-0"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "progress reprocess-pb"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    class: [
                                                                      reprocessData.isCompleted
                                                                        ? "progress-bar"
                                                                        : "progress-bar progress-bar-striped progress-bar-animated",
                                                                      reprocessData.nonRenderedReceipts >
                                                                      0
                                                                        ? "bg-danger"
                                                                        : "bg-success"
                                                                    ],
                                                                    style: {
                                                                      width:
                                                                        (reprocessData.isCompleted &&
                                                                        reprocessSummary
                                                                          .processExecutionInfo
                                                                          .actionFiltersRaw
                                                                          .renderLink
                                                                          ? 100
                                                                          : reprocessData.renderedReceiptsPercentage) +
                                                                        "%"
                                                                    },
                                                                    attrs: {
                                                                      role:
                                                                        "progressbar"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "mt-3 pl-2"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "p",
                                                                          {
                                                                            staticClass:
                                                                              "font-weight-bold text-left"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                                                % de Avance :\n                                                                            " +
                                                                                _vm._s(
                                                                                  reprocessData.isCompleted
                                                                                    ? 100
                                                                                    : reprocessData.renderedReceiptsPercentage
                                                                                ) +
                                                                                "%\n                                                                            "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-md-4 px-0"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "progress reprocess-pb"
                                                              },
                                                              [
                                                                _c("div", {
                                                                  class: [
                                                                    reprocessData.isCompleted
                                                                      ? "progress-bar"
                                                                      : "progress-bar progress-bar-striped progress-bar-animated",
                                                                    (reprocessData.secondCSV &&
                                                                      reprocessData.secondCSV ==
                                                                        "Failed") ||
                                                                    reprocessData.nonRenderedReceipts >
                                                                      0
                                                                      ? "bg-danger"
                                                                      : "bg-success"
                                                                  ],
                                                                  style: {
                                                                    width:
                                                                      reprocessData.secondCSV &&
                                                                      reprocessData.secondCSV !==
                                                                        "Skipped" &&
                                                                      reprocessSummary
                                                                        .processExecutionInfo
                                                                        .actionFiltersRaw
                                                                        .generateSecondtNotification
                                                                        ? "100%"
                                                                        : "0%"
                                                                  },
                                                                  attrs: {
                                                                    role:
                                                                      "progressbar"
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ]
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isVisibleResumen && _vm.isDataLoaded
                    ? _c("div", { staticClass: "alert alert-danger my-3" }, [
                        _c("strong", [
                          _vm._v(
                            "No se ha ejecutado un proceso de renderizado para los filtros\n                                seleccionados"
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isDataLoaded
                    ? _c("div", { staticClass: "alert alert-danger my-3" }, [
                        _c("strong", [
                          _vm._v(
                            "No se han encontrados pagos ejecutados según los filtros\n                                seleccionados"
                          )
                        ])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3 pl-0" }, [
                  _c("fieldset", { staticClass: "border p-2" }, [
                    _c("legend", { staticClass: "w-auto" }, [
                      _vm._v("Resumen Periodo")
                    ]),
                    _vm._v(" "),
                    _c(
                      "table",
                      { staticClass: "table table-bordered table-sm small" },
                      [
                        _c("thead"),
                        _vm._v(" "),
                        _c("tbody", [
                          _c("tr", [
                            _c("td", [
                              _vm._v(_vm._s(_vm.periodSummaryHeading[0]))
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  new Intl.NumberFormat("es-CL").format(
                                    _vm.periodSummary.totalDeComprobantes
                                  )
                                ) + "\n                                        "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", [
                              _vm._v(_vm._s(_vm.periodSummaryHeading[1]))
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  new Intl.NumberFormat("es-CL").format(
                                    _vm.periodSummary.totalRenderizados
                                  )
                                ) +
                                  " |\n                                            " +
                                  _vm._s(
                                    _vm.periodSummary
                                      .totalRenderizadosPercentage
                                  ) +
                                  "%"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", [
                              _vm._v(_vm._s(_vm.periodSummaryHeading[2]))
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  new Intl.NumberFormat("es-CL").format(
                                    _vm.periodSummary.totalErrors
                                  )
                                ) +
                                  " | " +
                                  _vm._s(
                                    _vm.periodSummary.totalErrorsPercentage
                                  ) +
                                  "% "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", [
                              _vm._v(_vm._s(_vm.periodSummaryHeading[3]))
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  new Intl.NumberFormat("es-CL").format(
                                    _vm.periodSummary.totalPagosPGU
                                  )
                                ) + " "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", [
                              _vm._v(_vm._s(_vm.periodSummaryHeading[4]))
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  new Intl.NumberFormat("es-CL").format(
                                    _vm.periodSummary.totalDisponibleIPS
                                  )
                                ) +
                                  " |\n                                            " +
                                  _vm._s(
                                    _vm.periodSummary
                                      .totalDisponsibleIPSPercentage
                                  ) +
                                  "%"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", [
                              _vm._v(_vm._s(_vm.periodSummaryHeading[5]))
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  new Intl.NumberFormat("es-CL").format(
                                    _vm.periodSummary
                                      .totalRegistrosDispuestosaMKT
                                  )
                                ) +
                                  " | " +
                                  _vm._s(
                                    _vm.periodSummary
                                      .totalRenderizadosPercentage
                                  ) +
                                  "%"
                              )
                            ])
                          ])
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "export-button" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-block btn-primary",
                        attrs: { type: "button" },
                        on: { click: _vm.exportTodoCVS }
                      },
                      [
                        _vm._v(
                          "\n                                Exportar Todo\n                            "
                        )
                      ]
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isVisible
            ? _c("fieldset", { staticClass: "border p-2" }, [
                _c("legend", { staticClass: "w-auto" }, [
                  _vm._v("Detalle del Proceso")
                ]),
                _vm._v(" "),
                _vm.isProcessDetailsInfo
                  ? _c(
                      "div",
                      { staticClass: "d-md-flex justify-content-md-end" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary col-md-2 mb-2",
                            attrs: { type: "button" },
                            on: { click: _vm.exportSelectionCVS }
                          },
                          [
                            _vm._v(
                              "\n                            Exportar selección\n                        "
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _vm.isProcessDetailsInfo
                      ? _c(
                          "table",
                          { staticClass: "table table-bordered table-sm" },
                          [
                            _vm._m(4),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              _vm._l(_vm.processDetailsInfo, function(
                                data,
                                index
                              ) {
                                return _c("tr", { key: index }, [
                                  _c("td", [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(data.periodo) +
                                        "\n                                        "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(data.idLiquidacion) +
                                        "\n                                        "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(data.rutCliente) +
                                        "\n                                        "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(data.rutBeneficiario) +
                                        "\n                                        "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(data.pgu) +
                                        "\n                                        "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(data.disponibleIps) +
                                        "\n                                        "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-link",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            _vm.downloadGenusPDF(
                                              data.intInstruccion,
                                              parseInt(data.idLiquidacion),
                                              data.intSeqRegistro
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("Link")]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    data.pgu &&
                                    data.pgu == "SI" &&
                                    data.disponibleIps &&
                                    data.disponibleIps == "SI"
                                      ? _c("div", [
                                          _c(
                                            "button",
                                            {
                                              staticClass: "btn btn-link",
                                              attrs: { type: "button" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.viewAttachment(
                                                    data.periodo,
                                                    data.rutCliente
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("Link")]
                                          )
                                        ])
                                      : _c("div", [_vm._v(" --")])
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    data.comprobanteGenus
                                      ? _c("div", [
                                          _c(
                                            "button",
                                            {
                                              staticClass: "btn btn-link",
                                              attrs: { type: "button" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.downloadPDF(index)
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                                    Link"
                                              )
                                            ]
                                          )
                                        ])
                                      : _c("div", [_vm._v("--")])
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(data.estadoNotificacion) +
                                        "\n\n                                        "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(data.causal) +
                                        "\n                                        "
                                    )
                                  ])
                                ])
                              }),
                              0
                            )
                          ]
                        )
                      : _c("div", { staticClass: "alert alert-danger" }, [
                          _c("strong", [_vm._v("Datos no encontrados.")])
                        ])
                  ])
                ])
              ])
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "card-header p-2 text-center bg-primary text-white" },
      [_c("h4", [_vm._v("Monitoreo Proceso Comprobantes de Pago de Pensión")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("div", { staticClass: "spinner-border text-dark" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-3" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-9 mb-4" }, [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: require("../assets/progress2.png"), alt: "" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "mb-0" }, [
      _c("strong", [
        _vm._v(
          "Opciones\n                                                                    Reprocesadas:"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Periodo")]),
        _vm._v(" "),
        _c("th", [_vm._v("ID Liquidación")]),
        _vm._v(" "),
        _c("th", [_vm._v("Rut Cliente")]),
        _vm._v(" "),
        _c("th", [_vm._v("Rut Beneficiario")]),
        _vm._v(" "),
        _c("th", [_vm._v("IPS")]),
        _vm._v(" "),
        _c("th", [_vm._v("Disponible IPS")]),
        _vm._v(" "),
        _c("th", [_vm._v("Comprobante Genus")]),
        _vm._v(" "),
        _c("th", [_vm._v("Link IPS")]),
        _vm._v(" "),
        _c("th", [_vm._v("Link Renderizado")]),
        _vm._v(" "),
        _c("th", [_vm._v("Estado Notificación")]),
        _vm._v(" "),
        _c("th", [_vm._v("Causal")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5cbc5a78", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cbc5a78","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Monitoring.vue
// module id = null
// module chunks = 